export class GrausInstrucao{
   
    id:number;
	descricao:string;
	usuarioAlteracao:number;
}